var SPARNATURAL_CONFIG_CORE 			=		"http://data.sparna.fr/ontologies/sparnatural-config-core#";

module.exports = Object.freeze({
    SPARNATURAL_CONFIG_CORE			: 		SPARNATURAL_CONFIG_CORE,
	LITERAL_LIST_PROPERTY 			: 		SPARNATURAL_CONFIG_CORE+'LiteralListProperty',
	LIST_PROPERTY 					: 		SPARNATURAL_CONFIG_CORE+'ListProperty',
	TIME_PROPERTY_PERIOD 			: 		SPARNATURAL_CONFIG_CORE+'TimeProperty-Period',
	TIME_PROPERTY_YEAR				: 		SPARNATURAL_CONFIG_CORE+'TimeProperty-Year',
	TIME_PROPERTY_DATE			 	: 		SPARNATURAL_CONFIG_CORE+'TimeProperty-Date',
	AUTOCOMPLETE_PROPERTY 			: 		SPARNATURAL_CONFIG_CORE+'AutocompleteProperty',
	SEARCH_PROPERTY 				: 		SPARNATURAL_CONFIG_CORE+'SearchProperty',
	STRING_EQUALS_PROPERTY 			: 		SPARNATURAL_CONFIG_CORE+'StringEqualsProperty',
	GRAPHDB_SEARCH_PROPERTY 		: 		SPARNATURAL_CONFIG_CORE+'GraphDBSearchProperty',
	NON_SELECTABLE_PROPERTY 		: 		SPARNATURAL_CONFIG_CORE+'NonSelectableProperty',
	BOOLEAN_PROPERTY 				: 		SPARNATURAL_CONFIG_CORE+'BooleanProperty',
	TREE_PROPERTY 					: 		SPARNATURAL_CONFIG_CORE+'TreeProperty',

	SPARQL_STRING			 		: 		SPARNATURAL_CONFIG_CORE+'sparqlString',
	ICON					 		: 		SPARNATURAL_CONFIG_CORE+'icon',
	FA_ICON					 		: 		SPARNATURAL_CONFIG_CORE+'faIcon',
	HIGHLIGHTED_ICON		 		: 		SPARNATURAL_CONFIG_CORE+'highlightedIcon',
	ORDER					 		: 		SPARNATURAL_CONFIG_CORE+'order',
	TOOLTIP					 		: 		SPARNATURAL_CONFIG_CORE+'tooltip',
	ENABLE_OPTIONAL			 		: 		SPARNATURAL_CONFIG_CORE+'enableOptional',
	ENABLE_NEGATION			 		: 		SPARNATURAL_CONFIG_CORE+'enableNegation',
	IS_MULTILINGUAL			 		: 		SPARNATURAL_CONFIG_CORE+'isMultilingual',

	DEFAULT_LABEL_PROPERTY	 		: 		SPARNATURAL_CONFIG_CORE+'defaultLabelProperty',

	SPARNATURAL_CLASS				: 		SPARNATURAL_CONFIG_CORE+'SparnaturalClass',
	NOT_INSTANTIATED_CLASS			: 		SPARNATURAL_CONFIG_CORE+'NotInstantiatedClass',
	RDFS_LITERAL					: 		"http://www.w3.org/2000/01/rdf-schema#Literal"
});